import type {
  MatterViewModel,
  MyMatterExpertsRow,
} from '~/modules/matters/matters.types';
import type { CreateMatterFormData } from '~/modules/matters/modals/CreateMatterModal';
import { CreateMatterModal } from '~/modules/matters/modals/CreateMatterModal';
import AddToMatterModal from '~/modules/matters/modals/AddToMatterModal';
import type { User } from '~/shared/types/connect';

interface Props {
  expert: User;
  isOwnProfile: boolean;
  isCreateMatterModalOpen: boolean;
  setIsCreateMatterModalOpen: (open: boolean) => void;
  isAddToMatterModalOpen: boolean;
  setIsAddToMatterModalOpen: (open: boolean) => void;
  mattersWithoutExpert: MatterViewModel[];
  experts: ReadonlyArray<MyMatterExpertsRow>;
  handleCreateMatter: (data: CreateMatterFormData) => void | Promise<void>;
  isCreatingMatter: boolean;
}

export function ExpertProfileModals({
  expert,
  isOwnProfile,
  isCreateMatterModalOpen,
  setIsCreateMatterModalOpen,
  isAddToMatterModalOpen,
  setIsAddToMatterModalOpen,
  mattersWithoutExpert,
  experts,
  handleCreateMatter,
  isCreatingMatter,
}: Props) {
  if (isOwnProfile) {
    return null;
  }

  return (
    <>
      <CreateMatterModal
        isOpen={isCreateMatterModalOpen}
        onClose={() => setIsCreateMatterModalOpen(false)}
        experts={experts}
        initialExpertId={expert.id}
        onSubmit={handleCreateMatter}
        isSubmitting={isCreatingMatter}
      />
      <AddToMatterModal
        isOpen={isAddToMatterModalOpen}
        onClose={() => setIsAddToMatterModalOpen(false)}
        expertId={expert.id}
        expert={expert}
        mattersWithoutExpert={mattersWithoutExpert}
      />
    </>
  );
}
